import { useSession } from "../store/session";
import { useHelpersSheet } from "../store/helpersSheet";
import { helperCountsFromStatus, helpersChip } from "../lib/helperPresentation";

/**
 * Topbar chip for this chat's helpers (sub-agents): blue while they work,
 * amber when one needs you, red when one failed, grey once they are all done.
 * Counts come from the 6 s /all-status poll; tapping opens the Helpers sheet.
 */
export default function HelpersChip() {
  const companyId = useSession((s) => s.activeCompanyId);
  const status = useSession((s) => (companyId ? s.sessionStatusByCompany[companyId] : undefined));
  const open = useHelpersSheet((s) => s.open);
  const expanded = useHelpersSheet((s) => !!companyId && s.companyId === companyId);
  const view = helpersChip(helperCountsFromStatus(status));
  if (!companyId || !view) return null;
  return (
    <button
      type="button"
      className={"helpersChip is-" + view.tone}
      aria-label={view.label}
      aria-haspopup="dialog"
      aria-expanded={expanded}
      onClick={(event) => open(companyId, event.currentTarget)}
    >
      <span className="helpersChip__dot" aria-hidden="true" />
      <span className="helpersChip__text">{view.text}</span>
      <span className="helpersChip__short" aria-hidden="true">{view.short}</span>
    </button>
  );
}
